import { UI_Main } from 'ui/components/4-habitats/Main/Main';
import { ModuleFeature } from 'features/Modules/DynamicModule/DynamicModuleFeature';
import { UI_Footer } from 'ui/components/4-habitats/Footer/Footer';
import { footerMapper } from 'helpers/mappers';
import { UI_FilterHero } from 'ui/components/3-organisms/FilterHero/FilterHero';
import { usePageContext } from 'application/contexts/PageContext';
import { TagsFetcher } from './TagsFetcher';
import { UI_NewsList } from 'ui/components/3-organisms/NewsList/NewsList';
import { NewsFetcher } from 'features/Modules/NewsList/NewsFetcher';
import { UI_FilterProps } from 'ui/components/2-molecules/Filter/Filter';
import { UI_Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import { useState } from 'react';
import { useSiteContext } from 'application/contexts/SiteContext';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export const FilteredLibraryPageFeature: React.FC<Content.FilteredLibraryPage> = ({ properties }) => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();
	const dictionary = useDictionaryContext();
	const footerArgs = footerMapper(pageContext.footer, siteContext.settings.globalTheme?.setTheme, dictionary);
	const { heading, pageSections, buttonText } = properties ?? {};
	const pageId = pageContext.id;
	const tagsFolderId = properties.filterTagsNode.id;
	const { tags } = TagsFetcher(tagsFolderId);
	const [activeTag, setActiveTag] = useState<Tags.Tag | null>(null);

	const allTranslation = dictionary.getValue('All');

	const filterHero = {
		title: heading,
		filter: {
			items: tags?.map((tag) => ({
				children: tag.tagName,
				title: tag.tagName,
				onClick: () => setActiveTag(tag),
				selected: activeTag?.guid === tag.guid,
			})),
		} as UI_FilterProps,
	};

	return (
		<>
			<UI_Main header={<UI_FilterHero {...filterHero} />}>
				{!tags?.length ? (
					<UI_Spinner style="large" />
				) : (
					<UI_NewsList
						count={0}
						offset={0}
						rootFolderId={pageId}
						newsFetcher={(rootId, limit, offset, filter) => NewsFetcher(rootId, limit, offset, filter, activeTag, allTranslation)}
						filter={!activeTag ? '[]' : `[{alias: "tags", values: ["${activeTag?.guid.replaceAll('-', '')}"] }]`}
						buttonText={buttonText}
					/>
				)}

				{pageSections.map((sectionModule, index) => (
					<ModuleFeature key={index} contentModule={sectionModule} />
				))}
			</UI_Main>
			{footerArgs && <UI_Footer {...footerArgs} />}
		</>
	);
};
